import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ENDPOINTS_SANITIZED } from '../../apps/xsight/src/app/utils/app-endpoints';

@Injectable({
  providedIn: 'root',
})
export class RouterHelperService {
  constructor(
    private router: Router
  ) {}

  public navigateToDashboardUnauthorizedPage() {
    this.router.navigate([APP_ENDPOINTS_SANITIZED.DASHBOARD_ERROR], {
        queryParams: { errorCode: 'unauthorized' },
    });
  }
}